import app from 'flarum/forum/app';
import UserPage from 'flarum/forum/components/UserPage';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';
import Link from 'flarum/common/components/Link';
import Placeholder from 'flarum/common/components/Placeholder';
import CommentPost from 'flarum/forum/components/CommentPost';

export default class UserLikesPage extends UserPage {
  oninit(vnode) {
    super.oninit(vnode);
    
    this.loading = true;
    this.moreResults = false;
    this.posts = [];
    this.loadLimit = 20;
    
    // 加载用户
    this.loadUser(m.route.param('username'));
  }

  show(user) {
    super.show(user);
    
    // 用户加载完成后，加载点赞的帖子
    if (this.user) {
      this.refresh();
    }
  }

  content() {
    if (this.posts.length === 0 && !this.loading) {
      return (
        <div className="UserLikesPage">
          <Placeholder text={app.translator.trans('tf-custom-profile.forum.likes.empty')} />
        </div>
      );
    }

    let footer;

    if (this.loading) {
      footer = <LoadingIndicator />;
    } else if (this.moreResults) {
      footer = (
        <div className="UserLikesPage-loadMore">
          <Button className="Button" onclick={this.loadMore.bind(this)}>
            {app.translator.trans('core.forum.user.posts_load_more_button')}
          </Button>
        </div>
      );
    }

    return (
      <div className="UserLikesPage">
        {/* <div className="UserLikesPage-header">
          <h2>{app.translator.trans('tf-custom-profile.forum.likes.title')}</h2>
          {this.user && (
            <p>{app.translator.trans('tf-custom-profile.forum.likes.description')} - {this.user.displayName()}</p>
          )}
        </div> */}
        
        <ul className="UserLikesPage-list">
          {this.posts.map((post) => (
            <li key={post.id()}>
              <div className="UserLikesPage-discussion">
                {app.translator.trans('core.forum.user.in_discussion_text', {
                  discussion: <Link href={app.route.post(post)}>{this.discussionTitle(post)}</Link>,
                })}
              </div>
              <CommentPost post={post} />
            </li>
          ))}
        </ul>
        <div className="UserLikesPage-loadMore">{footer}</div>
      </div>
    );
  }

  refresh() {
    this.loading = true;
    this.posts = [];

    m.redraw();

    this.loadResults().then(this.parseResults.bind(this));
  }

  loadResults(offset = 0) {
    if (!this.user) return Promise.resolve([]);

    return app.store.find('posts', {
      filter: {
        likedBy: this.user.id()
      },
      page: { offset, limit: this.loadLimit },
      sort: '-createdAt',
    });
  }

  loadMore() {
    this.loading = true;
    this.loadResults(this.posts.length).then(this.parseResults.bind(this));
  }

  parseResults(results) {
    this.loading = false;

    if (Array.isArray(results)) {
      this.posts.push(...results);
      this.moreResults = results.length >= this.loadLimit;
    } else if (results && results.data) {
      const posts = results.data || [];
      this.posts.push(...posts);
      this.moreResults = posts.length >= this.loadLimit;
    }

    m.redraw();

    return results;
  }

  discussionTitle(post) {
    const discussion = post.discussion();
    return discussion ? discussion.title() : '';
  }
}

